"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _Link = _interopRequireDefault(require("@sprinx/react-mui-components/Link"));

var _PageFooter = _interopRequireDefault(require("@sprinx/react-web/PageFooter"));

var _PageFooterColumn = _interopRequireDefault(require("@sprinx/react-web/PageFooterColumn"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FooterMenuColumn = _interopRequireDefault(require("./FooterMenuColumn"));

// import { Link as RouterLink } from 'react-router-dom';
// import { routeUrl } from '../../routesBuilder';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      background: theme.palette.background.default,
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      minHeight: 'unset',
      flexDirection: 'column'
    },
    row: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 24,
      flexDirection: 'row',
      flexWrap: 'wrap'
    },
    typo: {
      textTransform: theme.text.textTransformUppercase,
      fontSize: 15
    },
    links: {
      color: theme.palette.common.black
    }
  };
}, {
  name: 'FooterMenu'
}); // const getArticleHref = ({ path }) => routeUrl('article', { locale: 'cs', params: { path } });
// const getArticleHref = ({ id }) => {
//   return routeUrl('article', { locale: 'cs', params: { id } });
// };

var getArticleHref = function getArticleHref(_ref) {
  var href = _ref.href;
  return "/info".concat(href);
};

function FooterMenu(_ref2) {
  var pClasses = _ref2.classes,
      className = _ref2.className,
      footerItems = _ref2.footerItems,
      hideFooterItems = _ref2.hideFooterItems,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["classes", "className", "footerItems", "hideFooterItems"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  return /*#__PURE__*/_react.default.createElement(_PageFooter.default, (0, _extends2.default)({
    className: classes.root
  }, rest), !hideFooterItems && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.row
  }, (footerItems || []).map(function (i, idx) {
    return /*#__PURE__*/_react.default.createElement(_FooterMenuColumn.default, {
      title: t(i.title, {
        acceptString: true
      }),
      href: getArticleHref(i),
      key: idx.toString()
    }, /*#__PURE__*/_react.default.createElement("ul", null, (i.items || []).map(function (l, index) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: index.toString()
      }, /*#__PURE__*/_react.default.createElement(_Link.default, {
        to: getArticleHref(l),
        className: classes.links
      }, t(l.title, {
        acceptString: true
      })));
    })));
  })), /*#__PURE__*/_react.default.createElement(_PageFooterColumn.default, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.typo
  }, t('footer/copyright'))));
}

process.env.NODE_ENV !== "production" ? FooterMenu.propTypes = {
  classes: _propTypes.default.shape({
    column: _propTypes.default.string,
    container: _propTypes.default.string,
    links: _propTypes.default.string,
    root: _propTypes.default.string,
    row: _propTypes.default.string,
    typo: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  footerItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    href: _propTypes.default.string,
    title: _propTypes.default.string
  })),
  hideFooterItems: _propTypes.default.bool,
  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false])
} : void 0;
FooterMenu.defaultProps = {
  classes: undefined,
  className: undefined,
  footerItems: undefined,
  hideFooterItems: false,
  maxWidth: false
};
var _default = FooterMenu;
exports.default = _default;